import React from "react";
import { useSelector } from "react-redux";
import { stackedBarPairedPalette } from "../colors";
import D3StackedBar from "./D3StackedBar";
import RccCard from "../RccCard";
import { usePipelineMixIndustryData } from "../hooks/usePipelineMixData";

/**
 * PipelineMixByIndustryCard.jsx
 *
 * Thin wrapper card that renders Open/Qualified Pipeline Mix by Industry.
 * Uses the shared pipeline mix hook to fetch, transform, and supply chart data.
 *
 */
function PipelineMixByIndustryCard({ title, redirectToDashboard }) {
  const user = useSelector((state) => state.app.user || {});
  const { chartData, derivedCategories, appliedFilters, isLoading } =
    usePipelineMixIndustryData();

  const handleZoom = () => {
    console.log("Zooming card...");
  };

  return (
    <RccCard
      title={title || "Qualified Pipeline Mix by Industry"}
      isLoading={isLoading}
      redirectToDashboard={redirectToDashboard || "Open Pipeline Mix Analysis"}
      onZoomClick={handleZoom}
      appliedFilters={appliedFilters}
      focusVariant={"future"}
    >
      <D3StackedBar
        data={chartData}
        categories={derivedCategories}
        colorPalette={stackedBarPairedPalette}
        currencySymbol={user?.Currency}
        options={{
          showLabels: true,
          showLegend: true,
        }}
      />
    </RccCard>
  );
}

export default PipelineMixByIndustryCard;
